import Loader from 'components/Loader';
import { cn } from 'utils/utils';

export interface IButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  loading?: boolean;
}

const Button = ({ onClick, children, disabled, className, type = 'button', loading = false, ...props }: IButton) => {
  const loadingOrDisabled = disabled || loading;

  return (
    <button
      type={type}
      className={cn(
        'relative rounded-[8px] px-[16px] py-[12px] bg-primary text-white font-[MuseoSansCyrl]',
        className,
        loadingOrDisabled && 'opacity-50 cursor-not-allowed',
        !loadingOrDisabled && 'cursor-pointer'
      )}
      onClick={loadingOrDisabled ? undefined : onClick}
      disabled={loadingOrDisabled}
      {...props}
    >
      {/* Keep the button content invisible when loading to prevent layout shift */}
      <span className={cn(className, loading && 'invisible')}>{children}</span>

      {loading && (
        <span className='absolute inset-0 flex items-center justify-center'>
          <Loader />
        </span>
      )}
    </button>
  );
};

export default Button;
